module.exports = __webpack_public_path__ + "img/46800.0aa04876.jpg";